// extracted by mini-css-extract-plugin
export default {"brandPromo":"yG-z","carousel":"zG-z"};